import { getJson } from './client';
import type { HomeFeedResponseDto } from '../data/schemas/homeFeed';
import type { CursorPageResponse } from './bookings';

export function fetchHomeFeed() {
  return getJson<HomeFeedResponseDto>('/api/v1/home/feed');
}

// --- Home hot posts (communityservice HomePostController) ---

export type HotPostItemDto = {
  id: string;
  title: string;
  authorUserId: string;
  viewCount: number;
  likeCount: number;
  commentCount: number;
  createdAt: string;
};

export function fetchHomeHotPosts(params: { cursor?: string; size?: number } = {}) {
  const query = new URLSearchParams();
  if (params.cursor) query.set('cursor', params.cursor);
  if (params.size != null) query.set('size', String(params.size));
  const qs = query.toString();
  return getJson<CursorPageResponse<HotPostItemDto>>(
    `/api/v1/home/hot-posts${qs ? `?${qs}` : ''}`,
    { preserveAuthOnUnauthorized: true },
  );
}

// --- Home reviews (order HomeReviewController) ---

export type HomeReviewItemDto = {
  id: string;
  authorUserId: string;
  content: string;
  rating: number;
  studioId: string | null;
  studioName: string | null;
  createdAt: string;
};

export function fetchHomeReviews(params: { cursor?: string; size?: number } = {}) {
  const query = new URLSearchParams();
  if (params.cursor) query.set('cursor', params.cursor);
  if (params.size != null) query.set('size', String(params.size));
  const qs = query.toString();
  return getJson<CursorPageResponse<HomeReviewItemDto>>(
    `/api/v1/home/reviews${qs ? `?${qs}` : ''}`,
    { preserveAuthOnUnauthorized: true },
  );
}

// --- Home spaces (partner-space HomeSpaceController) ---

export type RecommendedSpaceDto = {
  id: string;
  name: string;
  description: string | null;
  address: string | null;
};

export function fetchRecommendedSpaces(params: { cursor?: string; size?: number } = {}) {
  const query = new URLSearchParams();
  if (params.cursor) query.set('cursor', params.cursor);
  if (params.size != null) query.set('size', String(params.size));
  const qs = query.toString();
  return getJson<CursorPageResponse<RecommendedSpaceDto>>(
    `/api/v1/home/recommended-spaces${qs ? `?${qs}` : ''}`,
    { preserveAuthOnUnauthorized: true },
  );
}

export type HomeCategoryDto = {
  id: string;
  name: string;
  iconUrl: string | null;
  studioCount: number;
};

export function fetchHomeCategories() {
  return getJson<HomeCategoryDto[]>('/api/v1/home/categories', { preserveAuthOnUnauthorized: true });
}
